import axios from "../../../../../../api/axiosInstance";
import {
  CreateProductStoreProductRequest,
  CreateProductStoreProductResponse,
} from "./types";

export const createProductStoreProduct = async (
  data: CreateProductStoreProductRequest,
): Promise<CreateProductStoreProductResponse> => {
  const response = await axios.post<CreateProductStoreProductResponse>(
    "/api/private/product-store/products",
    data,
  );
  return response.data;
};
